// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dropdown_methods_dropdown__Lcn3Y {
    position: relative;
    cursor: pointer;
}
img{

}
.Dropdown_methods_dropdown__Lcn3Y .disabled {
    cursor: not-allowed;
}
.Dropdown_methods_dropdown__Lcn3Y .selected {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;


    
}
.Dropdown_methods_dropdown__Lcn3Y .selected.open {
    z-index: 10000;
}
.Dropdown_methods_blockColor__XROSO{
    width: 100%;
    height: 40px;
    
}
.Dropdown_methods_dropdown__Lcn3Y .dropdown-items {
    position: absolute;
    z-index: 999;
    top: 0px;
    overflow: hidden;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    
    border-radius: 10px; 
    background-color: rgba(23, 26, 26);
}
.Dropdown_methods_dropdown__Lcn3Y .dropdown-items .item {
    display: flex;
    justify-content: left;
    padding: 10px;
    padding-left: 15px;
    cursor: pointer;
    color:white;
    font-family: Popins,sans-serif;
    font-weight: 400;
    font-size: 13px;
    
}
.Dropdown_methods_dropdown__Lcn3Y .dropdown-items .item:hover {
    background-color: green;
}
.Dropdown_methods_dropdown__Lcn3Y .blank {
    position: fixed;
    z-index: 998;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Dropdown_methods/Dropdown_methods.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;;AAEA;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;;;AAI3B;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;;AAEhB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,gBAAgB;IAChB,+BAA+B;IAC/B,gCAAgC;IAChC,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;;IAEnB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;;AAEnB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,YAAY;IACZ,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".dropdown :global {\n    position: relative;\n    cursor: pointer;\n}\nimg{\n\n}\n.dropdown :global .disabled {\n    cursor: not-allowed;\n}\n.dropdown :global .selected {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n\n    \n}\n.dropdown :global .selected.open {\n    z-index: 10000;\n}\n.blockColor{\n    width: 100%;\n    height: 40px;\n    \n}\n.dropdown :global .dropdown-items {\n    position: absolute;\n    z-index: 999;\n    top: 0px;\n    overflow: hidden;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    width: 100%;\n    height: fit-content;\n    \n    border-radius: 10px; \n    background-color: rgba(23, 26, 26);\n}\n.dropdown :global .dropdown-items .item {\n    display: flex;\n    justify-content: left;\n    padding: 10px;\n    padding-left: 15px;\n    cursor: pointer;\n    color:white;\n    font-family: Popins,sans-serif;\n    font-weight: 400;\n    font-size: 13px;\n    \n}\n.dropdown :global .dropdown-items .item:hover {\n    background-color: green;\n}\n.dropdown :global .blank {\n    position: fixed;\n    z-index: 998;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `Dropdown_methods_dropdown__Lcn3Y`,
	"blockColor": `Dropdown_methods_blockColor__XROSO`
};
export default ___CSS_LOADER_EXPORT___;
